var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg3Desktop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1354,
    height: 400,
    viewBox: "0 0 1354 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_368_106718)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 200,
    r: 309,
    fill: "url(#paint0_linear_368_106718)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_368_106718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262 -125L507.085 299.5H16.9148L262 -125Z",
    fill: "url(#paint1_linear_368_106718)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_368_106718",
    x: -313,
    y: -309,
    width: 1018,
    height: 1018,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 100,
    result: "effect1_foregroundBlur_368_106718"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_368_106718",
    x: -163.086,
    y: -305,
    width: 850.172,
    height: 784.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_368_106718"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_368_106718",
    x1: 102.216,
    y1: -23.3474,
    x2: 272,
    y2: 284.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61A2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37E2D8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_368_106718",
    x1: 262,
    y1: -125,
    x2: 262,
    y2: 441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22D695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D695",
    stopOpacity: 0.28
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg3Desktop);
export default __webpack_public_path__ + "static/media/bg3-desktop.7ae99c46ff43f3c0d8987ea4da54d594.svg";
export { ForwardRef as ReactComponent };